module.exports = __webpack_public_path__ + "img/nearby-a.14a8fcfe.png";